export default "__VITE_ASSET__8d2a6d64__"